// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knIu5X09zgjS3HxklmDb{min-width:0;max-height:100%}.NHEeG1IAKIPdgw1k8GOO{height:calc(100vh - 420px)}.lSIrNzuXGRTbljgH15lg{visibility:hidden}`, "",{"version":3,"sources":["webpack://./src/components/asset-management-system/custom-views/tabs/risk/cards/risk-factors-card/risk-factors-card.scss"],"names":[],"mappings":"AAEA,sBACI,WAAA,CACA,eAAA,CAGJ,sBACI,0BAAA,CAGJ,sBACI,iBAAA","sourcesContent":["@import \"~styles/size\";\n\n.card {\n    min-width: 0;\n    max-height: 100%;\n}\n\n.tableContainer {\n    height: calc(100vh - 420px);\n}\n\n.hiddenPagination {\n    visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpointXs": `458px`,
	"breakpointSm": `580px`,
	"breakpointMd": `768px`,
	"breakpointLg": `992px`,
	"breakpointXl": `1200px`,
	"breakpointXxl": `1600px`,
	"card": `knIu5X09zgjS3HxklmDb`,
	"tableContainer": `NHEeG1IAKIPdgw1k8GOO`,
	"hiddenPagination": `lSIrNzuXGRTbljgH15lg`
};
export default ___CSS_LOADER_EXPORT___;
